/**
 * The new order after one item is dragged onto another.
 *
 * The dragged item takes the target's place; it does not swap with it.
 * Dragging the first block onto the fourth makes it fourth, and everything
 * between shuffles up by one. Swapping is what the short version of this
 * function does — `[a[i], a[j]] = [a[j], a[i]]` — and it is wrong in a way
 * that is hard to name and obvious to feel: you drag one thing and two move.
 *
 * Returns null when there is nothing to do, so callers can skip the write
 * rather than sending an order identical to the one already stored.
 */
export default function reorderSiblings(ids, dragId, dropId) {
  if (!Array.isArray(ids) || dragId == null || dropId == null) return null;
  if (dragId === dropId) return null;

  const from = ids.indexOf(dragId);
  const to = ids.indexOf(dropId);
  // Both have to be siblings in the list given; a drop across parents is
  // re-parenting, which is a different operation with different consequences.
  if (from < 0 || to < 0) return null;

  const next = ids.slice();
  next.splice(to, 0, next.splice(from, 1)[0]);
  return next;
}
